module.exports = __webpack_public_path__ + "static/media/nopicture.d6cf9bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/js/assets/nopicture.jpg
// module id = 2651
// module chunks = 0